import React, {FC, useContext, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useNavigate, useParams} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {Employers} from '../employers-list/core/_models'
import {viewEmployers} from '../employers-list/core/_requests'

const imageUrl = process.env.REACT_APP_IMAGE_UPLOADS

const EmployersView: React.FC = () => {
  const {showAlert} = useContext(AlertContext)
  const navigate = useNavigate()
  const {id} = useParams()
  const [role, setRole] = useState<any>([])
  const [Employers, setData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [formImage, setFormImage] = useState<File | null>(null)

  //Image Target
  interface Event<T = EventTarget> {
    target: T
    // ...
  }

  useEffect(() => {
    viewEmployers(id).then((res: any) => {
      // console.log('ProfileHeaderView====', res)
      setData(res.Data)
    })
  }, [])

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'> Employer Details</h3>
          </div>
        </div>
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{Employers.company}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Designation</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
                {Employers.designation}
              </span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Gender</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>
              {Employers.gender == 1 ? 'Male' : 'Female'}

              </span>
            </div>
          </div>
         
        </div>
      </div>
    </>
  )
}

export default EmployersView
